import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveExportBiRunRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveExportBiRunRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveExportBiRunRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getExportBiRun() {
      return getState().run;
    },
  };
}

export { createSelector };
